import { inject, Injectable } from '@angular/core'
// import {Select, Store} from "@ngxs/store";
import { CognitoAccessToken } from 'amazon-cognito-identity-js'
import { from, Observable } from 'rxjs'
import { UserAccount } from '../../api/models/user-account.model'
import { AccountService } from '../../api/services/accounts.service'
import { CognitoAuthService } from './cognito-auth.service'
import { CognitoUserInfo } from './cognito-user-info'

@Injectable({
    providedIn: 'root'
})
export class AuthFacade {
    private authService: CognitoAuthService = inject(CognitoAuthService)
    private accountService: AccountService = inject(AccountService)
    signInGoogle(): Promise<void> {
        return this.authService.signInGoogle()
    }

    signOut(): Promise<void> {
        return this.authService.signOut()
    }

    getActiveAccessToken(): Observable<CognitoAccessToken> {
        return this.authService.getAccessToken()
    }

    getCurrentUser(): Observable<CognitoUserInfo | null> {
        return from(this.authService.currentUser())
    }

    getCurrentUserAccount(): Observable<UserAccount | undefined> {
        return from(this.accountService.getAccount())
    }

    async getRoles(): Promise<Array<string>> {
        const activeUser = await this.getCurrentUserAccount().toPromise()
        if (activeUser) {
            return activeUser.identityRoles
        }

        return []
    }

    async hasRequiredRole(access: Array<string>): Promise<boolean> {
        if (!access) {
            return true
        }
        const roles: Array<string> | undefined = await this.getRoles()

        return access.findIndex((item: any) => roles && roles.indexOf(item) > -1) > -1
    }
}
